import {connect} from 'react-redux';
import EntryDetailSummary from './EntryDetailSummary.jsx';
import {
  handleAdminManageRosterClick,
  handleViewRosterClick,
  handleSquadChangeClick,
  handleEventChangeClick,
  handleRemoveSquadClick
} from './actions';

const mapStateToProps = state => ({
  entryNumber: state.admin.entryDetail.entryNumber,
  groupCode: state.admin.entryDetail.groupCode,
  pairCode: state.admin.entryDetail.pairCode,
  readOnly: state.admin.entryDetail.readOnly,
  squadDateTime: state.admin.entryDetail.squadDateTime,
  timeZoneDisplayName: state.admin.entryDetail.timeZoneDisplayName,
  teamName: state.admin.entryDetail.teamName,
  divisionName: state.admin.entryDetail.divisionName,
  isCancelled: state.admin.entryDetail.isCancelled,
  tournamentName: state.admin.entryDetail.tournament.name,
  allowChangeBetweenFreeEvents: state.admin.entryDetail.tournament.allowChangeBetweenFreeEvents
});

const mapDispatchToProps = dispatch => ({
  onManageRosterClick: () => dispatch(handleAdminManageRosterClick()),
  onViewRosterClick: () => dispatch(handleViewRosterClick()),
  onChangeSquadClick: () => dispatch(handleSquadChangeClick()),
  onChangeEventClick: () => dispatch(handleEventChangeClick()),
  onRemoveSquadClick: () => dispatch(handleRemoveSquadClick())
});

export default connect(mapStateToProps, mapDispatchToProps)(EntryDetailSummary);



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryDetailSummaryContainer.jsx